import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { Body2 } from '../../../../components/Typography';

import './index.scss';

const RecommendedActionsDescription = ({ description }) => {
  return (
    <Body2 element='div' className='recommended-actions-description'>
      <Markdown rehypePlugins={rehypeRaw}>{description}</Markdown>
    </Body2>
  );
};

RecommendedActionsDescription.propTypes = {
  description: PropTypes.string,
};

export default RecommendedActionsDescription;
